import $ from 'jquery';
import { utils } from '../common/utils';
import type { IDeliveryInfo } from '../types';

export class DonationDeliveryOptions {
    private $donationFlow: JQuery<HTMLElement>;
    private $digitalDeliveryOption: JQuery<HTMLElement>;
    private $printedDeliveryOption: JQuery<HTMLElement>;
    private $emailDelivery: JQuery<HTMLElement>;
    private $printedRecipient: JQuery<HTMLElement>;
    private $printedAddress: JQuery<HTMLElement>;
    private $printedZipCode: JQuery<HTMLElement>;
    private $printedCity: JQuery<HTMLElement>;

    constructor(element: HTMLElement | JQuery<HTMLElement>) {
        this.$donationFlow = utils.isJquery(element) ? element : $(element);
        this.$digitalDeliveryOption = this.$donationFlow.find('input[name=rbdeliveryoptions][value=digitaldelivery]');
        this.$printedDeliveryOption = this.$donationFlow.find('input[name=rbdeliveryoptions][value=printeddelivery]');
        this.$emailDelivery = this.$donationFlow.find('input[name=tbdeliveryemail]');
        this.$printedRecipient = this.$donationFlow.find('input[name=tbrecipient]');
        this.$printedAddress = this.$donationFlow.find('input[name=tbaddress]');
        this.$printedZipCode = this.$donationFlow.find('input[name=tbpostalcode]');
        this.$printedCity = this.$donationFlow.find('input[name=tbcity]');
        this.initDeliverOptionsEvents();
    }

    get DeliveryInfo(): IDeliveryInfo {
        return {
            email: this.$emailDelivery.val(),
            recipient: this.$printedRecipient.val(),
            address: this.$printedAddress.val(),
            postalCode: this.$printedZipCode.val(),
            city: this.$printedCity.val(),
            digitalDelivery: this.$digitalDeliveryOption.is(':checked')
        };
    }

    deliveryOptionsValid(): boolean {
        if (!this.$digitalDeliveryOption.is(':checked') && !this.$printedDeliveryOption.is(':checked')) {
            this.$digitalDeliveryOption.addClass('is-invalid');
            this.$printedDeliveryOption.addClass('is-invalid');
            return false;
        }
        this.$digitalDeliveryOption.removeClass('is-invalid');
        this.$printedDeliveryOption.removeClass('is-invalid');

        if (this.$digitalDeliveryOption.is(':checked') && !utils.validEmail(this.$emailDelivery.val() as string)) {
            this.$emailDelivery.addClass('is-invalid');
            return false;
        }
        this.$emailDelivery.removeClass('is-invalid');

        if (this.$printedDeliveryOption.is(':checked')) {
            const fields = [this.$printedRecipient, this.$printedAddress, this.$printedZipCode, this.$printedCity];
            fields.forEach($f => {
                if ($f.val() === '') $f.addClass('is-invalid');
                else $f.removeClass('is-invalid');
            });
        }

        return true;
    }

    private initDeliverOptionsEvents(): void {
        // Toggle the digital/printed sections and notify listeners (e.g. the payment
        // options module) when the delivery method changes. This handler was lost in the
        // Gulp→Vite/TypeScript migration; behaviour matches the pre-upgrade site.
        const $digitalSection = this.$donationFlow.find('.donation-digitaldelivery');
        const $printedSection = this.$donationFlow.find('.donation-printeddelivery');
        this.$donationFlow.find('input[name=rbdeliveryoptions]').on('change', (evt) => {
            const delivery = (evt.currentTarget as HTMLInputElement).value;
            if (delivery === 'printeddelivery') {
                $digitalSection.fadeOut(200, () => $printedSection.fadeIn(200));
            } else {
                $printedSection.fadeOut(200, () => $digitalSection.fadeIn(200));
            }
            evt.currentTarget.dispatchEvent(new CustomEvent('deliveryoptions', { bubbles: true, detail: { delivery } }));
        });

        this.$donationFlow.on('renderpreview', (evt: JQuery.TriggeredEvent) => {
            const detail = (evt.originalEvent as CustomEvent).detail;
            if (detail.imagetype !== 'standard') {
                this.$digitalDeliveryOption.trigger('click');
                this.$printedDeliveryOption.prop('disabled', 'disabled');
            } else {
                this.$printedDeliveryOption.removeAttr('checked');
                this.$printedDeliveryOption.removeAttr('disabled');
            }
        });
    }
}
